import { isExpired, isOverLimit } from "./containers/Active/helpers";

const getPaymentType = (item) => item?.transactionType?.split("#")[1];

export const getBonusDepositWalletId = (item) =>
	item?.walletContributions?.[0]?.walletId || item?.walletId;

export const getDisabledBonusWalletIds = (paymentRecords = []) => [
	...new Set(
		paymentRecords
			.filter((item) => getPaymentType(item) === "BonusWalletDisabled")
			.map((item) => getBonusDepositWalletId(item))
			.filter(Boolean)
	),
];

const isDisabledBonusDeposit = (item, disabledWalletIds) => {
	const walletId = getBonusDepositWalletId(item);
	return walletId && disabledWalletIds.includes(walletId);
};

const filterDisabledBonusDeposits = (bonuses, paymentRecords) => {
	const disabledWalletIds = getDisabledBonusWalletIds(paymentRecords);
	return bonuses.filter((item) => !isDisabledBonusDeposit(item, disabledWalletIds));
};

export const findMatchingBonusData = (freeSpinAndBonusItems, bonusList) => {
	return freeSpinAndBonusItems.map((item) => {
		const matchingBonus = bonusList.find((bonus) =>
			bonus.walletContributions.some(
				(contribution) => contribution.walletId === item.walletId
			)
		);
		return {
			...item,
			matchingBonus: matchingBonus || null,
		};
	});
};

export const prepareBonusData = (bonusList, balance) => {
	const normalBonuses = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100
	);
	const filteredOverLimitBonuses = normalBonuses.filter((item) => !isOverLimit(item));
	const availableBonuses = filteredOverLimitBonuses.filter((item) => !isExpired(item));
	const activeBonuses = filterDisabledBonusDeposits(availableBonuses, bonusList);
	const disabledWalletIds = getDisabledBonusWalletIds(bonusList);

	const freeSpinAndBonusItems = Object.values(balance).filter(
		(wallet) => wallet.type === "Bonus" && !disabledWalletIds.includes(wallet.walletId)
	);

	const existingWalletIds = activeBonuses.map((bonus) => getBonusDepositWalletId(bonus));

	const matchedFreeSpinAndBonuses = findMatchingBonusData(
		freeSpinAndBonusItems.filter((wallet) => !existingWalletIds.includes(wallet.walletId)),
		bonusList
	);

	return activeBonuses.concat(matchedFreeSpinAndBonuses);
};

const filterActiveBonuses = (bonusList, balance) => {
	const normalBonuses = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100
	);
	const filteredOverLimitBonuses = normalBonuses.filter((item) => !isOverLimit(item));
	const availableBonuses = filteredOverLimitBonuses.filter((item) => !isExpired(item));
	const activeBonuses = filterDisabledBonusDeposits(availableBonuses, bonusList);
	const disabledWalletIds = getDisabledBonusWalletIds(bonusList);

	const freeSpinAndBonusItems = Object.values(balance).filter(
		(wallet) => wallet.type === "Bonus" && !disabledWalletIds.includes(wallet.walletId)
	);

	return activeBonuses.concat(freeSpinAndBonusItems);
};

export const filterBonusList = (bonusList, balance) => {
	const active = filterActiveBonuses(bonusList, balance);

	const completed = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio === 100
	);

	const expired = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100 &&
			(isExpired(item) || isOverLimit(item))
	);

	return { active, completed, expired };
};
